// //======================paginationParams============
export const PAGE_RANGE = 2;
export const PER_PAGE_COUNT = 8;

export const Cat1Options = [
  { category: 'Afghan', subcategories: [] },
  { category: 'African', subcategories: ['Senegalese', 'South African'] },
  { category: 'American (New)', subcategories: [] },
  { category: 'American (Traditional)', subcategories: [] },
  { category: 'Andalusian', subcategories: [] },
  { category: 'Arabian', subcategories: [] },
  { category: 'Arab Pizza', subcategories: [] },
  { category: 'Argentine', subcategories: [] },
  { category: 'Armenian', subcategories: [] },
  { category: 'Asian Fusion', subcategories: [] },
  { category: 'Asturian', subcategories: [] },
  { category: 'Australian', subcategories: [] },
  { category: 'Austrian', subcategories: [] },
  { category: 'Baguettes', subcategories: [] },
  { category: 'Bangladeshi', subcategories: [] },
  { category: 'Barbeque', subcategories: [] },
  { category: 'Basque', subcategories: [] },
  { category: 'Bavarian', subcategories: [] },
  { category: 'Beer Garden', subcategories: [] },
  { category: 'Beer Hall', subcategories: [] },
  { category: 'Beisl', subcategories: [] },
  { category: 'Belgian', subcategories: [] },
  { category: 'Flemish', subcategories: [] },
  { category: 'Bistros', subcategories: [] },
  { category: 'Black Sea', subcategories: [] },
  { category: 'Brasseries', subcategories: [] },
  { category: 'Brazilian', subcategories: ['Brazilian Empanadas', 'Central Brazilian', 'Northeastern Brazilian', 'Northern Brazilian', 'Rodizios'] },
  { category: 'Breakfast & Brunch', subcategories: ['Pancakes'] },
  { category: 'British', subcategories: [] },
  { category: 'Buffets', subcategories: [] },
  { category: 'Bulgarian', subcategories: [] },
  { category: 'Burgers', subcategories: [] },
  { category: 'Burmese', subcategories: [] },
  { category: 'Cafes', subcategories: [] },
  { category: 'Themed Cafes', subcategories: [] },
  { category: 'Cafeteria', subcategories: [] },
  { category: 'Cajun/Creole', subcategories: [] },
  { category: 'Cambodian', subcategories: [] },
  { category: 'Canadian (New)', subcategories: [] },
  { category: 'Canteen', subcategories: [] },
  { category: 'Caribbean', subcategories: ['Dominican', 'Haitian', 'Puerto Rican', 'Trinidadian'] },
  { category: 'Catalan', subcategories: [] },
  { category: 'Cheesesteaks', subcategories: [] },
  { category: 'Chicken Shop', subcategories: [] },
  { category: 'Chicken Wings', subcategories: [] },
  { category: 'Chilean', subcategories: [] },
  { category: 'Chinese', subcategories: ['Cantonese', 'Congee', 'Dim Sum', 'Fuzhou', 'Hainan', 'Hakka', 'Henghwa', 'Hokkien', 'Hunan', 'Pekinese', 'Shanghainese', 'Szechuan', 'Teochew'] },
  { category: 'Comfort Food', subcategories: [] },
  { category: 'Corsican', subcategories: [] },
  { category: 'Creperies', subcategories: [] },
  { category: 'Cuban', subcategories: [] },
  { category: 'Curry Sausage', subcategories: [] },
  { category: 'Cypriot', subcategories: [] },
  { category: 'Czech', subcategories: [] },
  { category: 'Czech/Slovakian', subcategories: [] },
  { category: 'Danish', subcategories: [] },
  { category: 'Delis', subcategories: [] },
  { category: 'Diners', subcategories: [] },
  { category: 'Dinner Theater', subcategories: [] },
  { category: 'Dumplings', subcategories: [] },
  { category: 'Eastern European', subcategories: [] },
  { category: 'Eritrean', subcategories: [] },
  { category: 'Ethiopian', subcategories: [] },
  { category: 'Fast Food', subcategories: [] },
  { category: 'Filipino', subcategories: [] },
  { category: 'Fischbroetchen', subcategories: [] },
  { category: 'Fish & Chips', subcategories: [] },
  { category: 'Flatbread', subcategories: [] },
  { category: 'Fondue', subcategories: [] },
  { category: 'Food Court', subcategories: [] },
  { category: 'Food Stands', subcategories: [] },
  { category: 'Freiduria', subcategories: [] },
  { category: 'French', subcategories: ['Alsatian', 'Auvergnat', 'Berrichon', 'Bourguignon', 'Mauritius', 'Nicoise', 'Provencal', 'Reunion'] },
  { category: 'French Southwest', subcategories: [] },
  { category: 'Galician', subcategories: [] },
  { category: 'Game Meat', subcategories: [] },
  { category: 'Gastropubs', subcategories: [] },
  { category: 'Georgian', subcategories: [] },
  { category: 'German', subcategories: ['Baden', 'Eastern German', 'Franconian', 'Hessian', 'Northern German', 'Palatine', 'Rhinelandian'] },
  { category: 'Giblets', subcategories: [] },
  { category: 'Gluten-Free', subcategories: [] },
  { category: 'Greek', subcategories: [] },
  { category: 'Guamanian', subcategories: [] },
  { category: 'Halal', subcategories: [] },
  { category: 'Hawaiian', subcategories: [] },
  { category: 'Heuriger', subcategories: [] },
  { category: 'Himalayan/Nepalese', subcategories: [] },
  { category: 'Honduran', subcategories: [] },
  { category: 'Hong Kong Style Cafe', subcategories: [] },
  { category: 'Hot Dogs', subcategories: [] },
  { category: 'Hot Pot', subcategories: [] },
  { category: 'Hungarian', subcategories: [] },
  { category: 'Iberian', subcategories: [] },
  { category: 'Indian', subcategories: [] },
  { category: 'Indonesian', subcategories: [] },
  { category: 'International', subcategories: [] },
  { category: 'Irish', subcategories: [] },
  { category: 'Island Pub', subcategories: [] },
  { category: 'Israeli', subcategories: [] },
  { category: 'Italian', subcategories: ['Abruzzese', 'Altoatesine', 'Apulian', 'Calabrian', 'Cucina Campana', 'Emilian', 'Friulan', 'Ligurian', 'Lumbard', 'Napoletana', 'Piemonte', 'Roman', 'Sardinian', 'Sicilian', 'Tuscan', 'Venetian'] },
  { category: 'Japanese', subcategories: ['Blowfish', 'Conveyor Belt Sushi', 'Donburi', 'Gyudon', 'Oyakodon', 'Hand Rolls', 'Horumon', 'Izakaya', 'Japanese Curry', 'Kaiseki', 'Kushikatsu', 'Oden', 'Okinawan', 'Okonomiyaki', 'Onigiri', 'Ramen', 'Robatayaki', 'Soba', 'Sukiyaki', 'Takoyaki', 'Tempura', 'Teppanyaki', 'Tonkatsu', 'Udon', 'Unagi', 'Western Style Japanese Food', 'Yakiniku', 'Yakitori'] },
  { category: 'Jewish', subcategories: [] },
  { category: 'Kebab', subcategories: [] },
  { category: 'Kopitiam', subcategories: [] },
  { category: 'Korean', subcategories: [] },
  { category: 'Kosher', subcategories: [] },
  { category: 'Kurdish', subcategories: [] },
  { category: 'Laos', subcategories: [] },
  { category: 'Laotian', subcategories: [] },
  { category: 'Latin American', subcategories: ['Colombian', 'Salvadoran', 'Venezuelan'] },
  { category: 'Live/Raw Food', subcategories: [] },
  { category: 'Lyonnais', subcategories: [] },
  { category: 'Malaysian', subcategories: ['Mamak', 'Nyonya'] },
  { category: 'Meatballs', subcategories: [] },
  { category: 'Mediterranean', subcategories: [] },
  { category: 'Falafel', subcategories: [] },
  { category: 'Mexican', subcategories: ['Eastern Mexican', 'Jaliscan', 'Northern Mexican', 'Oaxacan', 'Pueblan', 'Tacos', 'Tamales', 'Yucatan'] },
  { category: 'Middle Eastern', subcategories: ['Egyptian', 'Lebanese'] },
  { category: 'Milk Bars', subcategories: [] },
  { category: 'Modern Australian', subcategories: [] },
  { category: 'Modern European', subcategories: [] },
  { category: 'Mongolian', subcategories: [] },
  { category: 'Moroccan', subcategories: [] },
  { category: 'New Mexican Cuisine', subcategories: [] },
  { category: 'New Zealand', subcategories: [] },
  { category: 'Nicaraguan', subcategories: [] },
  { category: 'Night Food', subcategories: [] },
  { category: 'Nikkei', subcategories: [] },
  { category: 'Noodles', subcategories: [] },
  { category: 'Norcinerie', subcategories: [] },
  { category: 'Open Sandwiches', subcategories: [] },
  { category: 'Oriental', subcategories: [] },
  { category: 'Pakistani', subcategories: [] },
  { category: 'Pan Asian', subcategories: [] },
  { category: 'Parent Cafes', subcategories: [] },
  { category: 'Parma', subcategories: [] },
  { category: 'Persian/Iranian', subcategories: [] },
  { category: 'Peruvian', subcategories: [] },
  { category: 'PF/Comercial', subcategories: [] },
  { category: 'Pita', subcategories: [] },
  { category: 'Pizza', subcategories: [] },
  { category: 'Polish', subcategories: [] },
  { category: 'Pierogis', subcategories: [] },
  { category: 'Polynesian', subcategories: [] },
  { category: 'Pop-Up Restaurants', subcategories: [] },
  { category: 'Portuguese', subcategories: ['Alentejo', 'Algarve', 'Azores', 'Beira', 'Fado Houses', 'Madeira', 'Minho', 'Ribatejo', 'Tras-os-Montes'] },
  { category: 'Potatoes', subcategories: [] },
  { category: 'Poutineries', subcategories: [] },
  { category: 'Pub Food', subcategories: [] },
  { category: 'Rice', subcategories: [] },
  { category: 'Romanian', subcategories: [] },
  { category: 'Rotisserie Chicken', subcategories: [] },
  { category: 'Russian', subcategories: [] },
  { category: 'Salad', subcategories: [] },
  { category: 'Sandwiches', subcategories: [] },
  { category: 'Scandinavian', subcategories: [] },
  { category: 'Schnitzel', subcategories: [] },
  { category: 'Scottish', subcategories: [] },
  { category: 'Seafood', subcategories: [] },
  { category: 'Serbo Croatian', subcategories: [] },
  { category: 'Signature Cuisine', subcategories: [] },
  { category: 'Singaporean', subcategories: [] },
  { category: 'Slovakian', subcategories: [] },
  { category: 'Somali', subcategories: [] },
  { category: 'Soul Food', subcategories: [] },
  { category: 'Soup', subcategories: [] },
  { category: 'Southern', subcategories: [] },
  { category: 'Spanish', subcategories: ['Arroceria/Paella'] },
  { category: 'Sri Lankan', subcategories: [] },
  { category: 'Steakhouses', subcategories: [] },
  { category: 'Supper Clubs', subcategories: [] },
  { category: 'Sushi Bars', subcategories: [] },
  { category: 'Swabian', subcategories: [] },
  { category: 'Swedish', subcategories: [] },
  { category: 'Swiss Food', subcategories: [] },
  { category: 'Syrian', subcategories: [] },
  { category: 'Tabernas', subcategories: [] },
  { category: 'Taiwanese', subcategories: [] },
  { category: 'Tapas Bars', subcategories: [] },
  { category: 'Tapas/Small Plates', subcategories: [] },
  { category: 'Tavola Calda', subcategories: [] },
  { category: 'Tex-Mex', subcategories: [] },
  { category: 'Thai', subcategories: [] },
  { category: 'Traditional Norwegian', subcategories: [] },
  { category: 'Traditional Swedish', subcategories: [] },
  { category: 'Trattorie', subcategories: [] },
  { category: 'Turkish', subcategories: ['Chee Kufta', 'Gozleme', 'Homemade Food', 'Lahmacun', 'Ottoman Cuisine', 'Turkish Ravioli'] },
  { category: 'Ukrainian', subcategories: [] },
  { category: 'Uzbek', subcategories: [] },
  { category: 'Vegan', subcategories: [] },
  { category: 'Vegetarian', subcategories: [] },
  { category: 'Venison', subcategories: [] },
  { category: 'Vietnamese', subcategories: [] },
  { category: 'Waffles', subcategories: [] },
  { category: 'Wok', subcategories: [] },
  { category: 'Wraps', subcategories: [] },
  { category: 'Yugoslav', subcategories: [] }
];

export const Cat2Options = [
  { category: 'Acai Bowls', subcategories: [] },
  { category: 'Backshop', subcategories: [] },
  { category: 'Bagels', subcategories: [] },
  { category: 'Bakeries', subcategories: [] },
  { category: 'Beer, Wine & Spirits', subcategories: [] },
  { category: 'Bento', subcategories: [] },
  { category: 'Beverage Store', subcategories: [] },
  { category: 'Breweries', subcategories: [] },
  { category: 'Brewpubs', subcategories: [] },
  { category: 'Bubble Tea', subcategories: [] },
  { category: 'Butcher', subcategories: [] },
  { category: 'Chimney Cakes', subcategories: [] },
  { category: 'Churros', subcategories: [] },
  { category: 'Cideries', subcategories: [] },
  { category: 'Coffee & Tea', subcategories: [] },
  { category: 'Coffee & Tea Supplies', subcategories: [] },
  { category: 'Coffee Roasteries', subcategories: [] },
  { category: 'Convenience Stores', subcategories: [] },
  { category: 'CSA', subcategories: [] },
  { category: 'Cupcakes', subcategories: [] },
  { category: 'Custom Cakes', subcategories: [] },
  { category: 'Delicatessen', subcategories: [] },
  { category: 'Desserts', subcategories: [] },
  { category: 'Distilleries', subcategories: [] },
  { category: 'Do-It-Yourself Food', subcategories: [] },
  { category: 'Donairs', subcategories: [] },
  { category: 'Donuts', subcategories: [] },
  { category: 'Empanadas', subcategories: [] },
  { category: 'Ethical Grocery', subcategories: [] },
  { category: 'Farmers Market', subcategories: [] },
  { category: 'Fishmonger', subcategories: [] },
  { category: 'Food Delivery Services', subcategories: [] },
  { category: 'Food Trucks', subcategories: [] },
  { category: 'Friterie', subcategories: [] },
  { category: 'Gelato', subcategories: [] },
  { category: 'Grocery', subcategories: [] },
  { category: 'Hawker Centre', subcategories: [] },
  { category: 'Honey', subcategories: [] },
  { category: 'Ice Cream & Frozen Yogurt', subcategories: [] },
  { category: 'Imported Food', subcategories: [] },
  { category: 'International Grocery', subcategories: [] },
  { category: 'Internet Cafes', subcategories: [] },
  { category: 'Japanese Sweets', subcategories: [] },
  { category: 'Taiyaki', subcategories: [] },
  { category: 'Juice Bars & Smoothies', subcategories: [] },
  { category: 'Kiosk', subcategories: [] },
  { category: 'Kombucha', subcategories: [] },
  { category: 'Meaderies', subcategories: [] },
  { category: 'Milkshake Bars', subcategories: [] },
  { category: 'Mulled Wine', subcategories: [] },
  { category: 'Nasi Lemak', subcategories: [] },
  { category: 'Organic Stores', subcategories: [] },
  { category: 'Panzerotti', subcategories: [] },
  { category: 'Parent Cafes', subcategories: [] },
  { category: 'Patisserie/Cake Shop', subcategories: [] },
  { category: 'Piadina', subcategories: [] },
  { category: 'Poke', subcategories: [] },
  { category: 'Pretzels', subcategories: [] },
  { category: 'Salumerie', subcategories: [] },
  { category: 'Shaved Ice', subcategories: [] },
  { category: 'Shaved Snow', subcategories: [] },
  { category: 'Smokehouse', subcategories: [] },
  { category: 'Specialty Food', subcategories: [] },
  { category: 'Candy Stores', subcategories: [] },
  { category: 'Cheese Shops', subcategories: [] },
  { category: 'Chocolatiers & Shops', subcategories: [] },
  { category: 'Dagashi', subcategories: [] },
  { category: 'Dried Fruit', subcategories: [] },
  { category: 'Frozen Food', subcategories: [] },
  { category: 'Fruits & Veggies', subcategories: [] },
  { category: 'Health Markets', subcategories: [] },
  { category: 'Herbs & Spices', subcategories: [] },
  { category: 'Macarons', subcategories: [] },
  { category: 'Meat Shops', subcategories: [] },
  { category: 'Olive Oil', subcategories: [] },
  { category: 'Pasta Shops', subcategories: [] },
  { category: 'Popcorn Shops', subcategories: [] },
  { category: 'Seafood Markets', subcategories: [] },
  { category: 'Tofu Shops', subcategories: [] },
  { category: 'Street Vendors', subcategories: [] },
  { category: 'Sugar Shacks', subcategories: [] },
  { category: 'Tea Rooms', subcategories: [] },
  { category: 'Torshi', subcategories: [] },
  { category: 'Tortillas', subcategories: [] },
  { category: 'Water Stores', subcategories: [] },
  { category: 'Wineries', subcategories: [] },
  { category: 'Zapiekanka', subcategories: [] }
];

export const Cat3Options = [
  { category: 'General Exercise', subcategories: ['Nature', 'Yoga', 'Walking', 'Rowing', 'Cycling', 'Jogging', 'Hiking', 'Marathons', '5K', '10K', 'Half Marathons'] },
  { category: 'Barbers', subcategories: [] },
  { category: 'Cosmetics & Beauty Supply', subcategories: ['Day Spas', 'Eyebrow Services', 'Eyelash Service', 'Foot Care', 'Hair Extensions', 'Hair Removal', 'Waxing', 'Hair Salons', 'Makeup Artists', 'Massage', 'Medical Spas', 'Nail Salons', 'Skin Care'] },
  { category: 'Acupuncture', subcategories: [] },
  { category: 'Alternative Medicine', subcategories: ['Animal Assisted Therapy', 'Assisted Living Facilities', 'Ayurveda'] },
  { category: 'Behavior Analysts', subcategories: [] },
  { category: 'Blood & Plasma Donation Centers', subcategories: [] },
  { category: 'Body Contouring', subcategories: [] },
  { category: 'Cannabis Clinics', subcategories: ['Cannabis Tours', 'Cannabis Collective'] },
  { category: 'Chiropractors', subcategories: [] },
  { category: 'Colonics', subcategories: [] },
  { category: 'Concierge Medicine', subcategories: [] },
  { category: 'Counseling & Mental Health', subcategories: ['Psychoanalysts', 'Psychologists', 'Psychotherapists', 'Sophrologists', 'Sports Psychologists'] },
  { category: 'Crisis Pregnancy Centers', subcategories: [] },
  { category: 'Cryotherapy', subcategories: [] },
  { category: 'Dental Hygienists', subcategories: [] },
  { category: 'Mobile Clinics', subcategories: [] },
  { category: 'Storefront Clinics', subcategories: [] },
  { category: 'Dentists', subcategories: ['Cosmetic Dentists', 'Endodontists', 'General Dentistry', 'Oral Surgeons', 'Orthodontists', 'Pediatric Dentists', 'Periodontists'] },
  { category: 'Diagnostic Services', subcategories: ['Diagnostic Imaging', 'Laboratory Testing'] },
  { category: 'Dialysis Clinics', subcategories: [] },
  { category: 'Dietitians', subcategories: [] },
  { category: 'Doctors', subcategories: ['Addiction Medicine', 'Allergists', 'Anesthesiologists', 'Audiologist', 'Cardiologists', 'Cosmetic Surgeons', 'Dermatologists', 'Ear Nose & Throat', 'Emergency Medicine', 'Endocrinologists', 'Family Practice', 'Fertility', 'Gastroenterologist', 'Geneticists', 'Gerontologists', 'Hepatologists', 'Homeopathic', 'Hospitalists', 'Immunodermatologists', 'Infectious Disease Specialists', 'Internal Medicine', 'Naturopathic/Holistic', 'Nephrologists', 'Neurologist', 'Neuropathologists', 'Neurotologists', 'Obstetricians & Gynecologists', 'Oncologist', 'Ophthalmologists', 'Retina Specialists', 'Orthopedists', 'Osteopathic Physicians', 'Otologists', 'Pain Management', 'Pathologists', 'Pediatricians', 'Phlebologists', 'Plastic Surgeons', 'Podiatrists', 'Preventive Medicine', 'Proctologists', 'Psychiatrists', 'Pulmonologist', 'Radiologists', 'Rheumatologists', 'Spine Surgeons', 'Sports Medicine', 'Surgeons', 'Tattoo Removal', 'Toxicologists', 'Tropical Medicine', 'Undersea/Hyperbaric Medicine', 'Urologists', 'Vascular Medicine'] },
  { category: 'Doulas', subcategories: [] },
  { category: 'Emergency Rooms', subcategories: [] },
  { category: 'Float Spa', subcategories: [] },
  { category: 'Habilitative Services', subcategories: [] },
  { category: 'Halfway Houses', subcategories: [] },
  { category: 'Halotherapy', subcategories: [] },
  { category: 'Health Coach', subcategories: [] },
  { category: 'Health Insurance Offices', subcategories: [] },
  { category: 'Hearing Aid Providers', subcategories: ['Hearing Aids'] },
  { category: 'Herbal Shops', subcategories: [] },
  { category: 'Home Health Care', subcategories: [] },
  { category: 'Hospice', subcategories: [] },
  { category: 'Hospitals', subcategories: [] },
  { category: 'Hydrotherapy', subcategories: [] },
  { category: 'Hypnosis/Hypnotherapy', subcategories: [] },
  { category: 'IV Hydration', subcategories: [] },
  { category: 'Lactation Services', subcategories: [] },
  { category: 'Laser Eye Surgery/Lasik', subcategories: [] },
  { category: 'Lice Services', subcategories: [] },
  { category: 'Massage Therapy', subcategories: [] },
  { category: 'Medical Cannabis Referrals', subcategories: [] },
  { category: 'Medical Centers', subcategories: ['Bulk Billing'] },
  { category: 'Osteopaths', subcategories: [] },
  { category: 'Walk-in Clinics', subcategories: [] },
  { category: 'Medical Foot Care', subcategories: [] },
  { category: 'Medical Spas', subcategories: [] },
  { category: 'Aestheticians', subcategories: [] },
  { category: 'Medical Transportation', subcategories: [] },
  { category: 'Memory Care', subcategories: [] },
  { category: 'Midwives', subcategories: [] },
  { category: 'Nurse Practitioner', subcategories: [] },
  { category: 'Nutritionists', subcategories: [] },
  { category: 'Occupational Therapy', subcategories: [] },
  { category: 'Optometrists', subcategories: [] },
  { category: 'Organ & Tissue Donor Services', subcategories: [] },
  { category: 'Orthotics', subcategories: [] },
  { category: 'Oxygen Bars', subcategories: [] },
  { category: 'Personal Care Services', subcategories: [] },
  { category: 'Pharmacy', subcategories: [] },
  { category: 'Physical Therapy', subcategories: [] },
  { category: 'Placenta Encapsulations', subcategories: [] },
  { category: 'Postpartum Care', subcategories: [] },
  { category: 'Prenatal/Perinatal Care', subcategories: [] },
  { category: 'Prosthetics', subcategories: [] },
  { category: 'Prosthodontists', subcategories: [] },
  { category: 'Psychotechnical Tests', subcategories: [] },
  { category: 'Reflexology', subcategories: [] },
  { category: 'Rehabilitation Center', subcategories: [] },
  { category: 'Reiki', subcategories: [] },
  { category: 'Reproductive Health Services', subcategories: [] },
  { category: 'Retirement Homes', subcategories: [] },
  { category: 'Saunas', subcategories: [] },
  { category: 'Skilled Nursing', subcategories: [] },
  { category: 'Sleep Specialists', subcategories: [] },
  { category: 'Speech Therapists', subcategories: [] },
  { category: 'Sperm Clinic', subcategories: [] },
  { category: 'Traditional Chinese Medicine', subcategories: ['Tui Na'] },
  { category: 'Ultrasound Imaging Centers', subcategories: [] },
  { category: 'Urgent Care', subcategories: [] },
  { category: 'Weight Loss Centers', subcategories: [] }
];

export const Cat4Options = [
  { category: 'Acne Treatment', subcategories: [] },
  { category: 'Barbers', subcategories: [] },
  { category: 'Cosmetics & Beauty Supply', subcategories: [] },
  { category: 'Day Spas', subcategories: [] },
  { category: 'Erotic Massage', subcategories: [] },
  { category: 'Eyebrow Services', subcategories: [] },
  { category: 'Eyelash Service', subcategories: [] },
  { category: 'Foot Care', subcategories: [] },
  { category: 'Hair Extensions', subcategories: [] },
  { category: 'Hair Loss Centers', subcategories: [] },
  { category: 'Hair Removal', subcategories: ['Laser Hair Removal', 'Sugaring', 'Threading Services', 'Waxing'] },
  { category: 'Hair Salons', subcategories: ['Blow Dry/Out Services', 'Hair Stylists', 'Kids Hair Salons', 'Men’s Hair Salons'] },
  { category: 'Hot Springs', subcategories: [] },
  { category: 'Makeup Artists', subcategories: [] },
  { category: 'Massage', subcategories: [] },
  { category: 'Medical Spas', subcategories: [] },
  { category: 'Nail Salons', subcategories: ['Nail Technicians'] },
  { category: 'Perfume', subcategories: [] },
  { category: 'Permanent Makeup', subcategories: [] },
  { category: 'Piercing', subcategories: [] },
  { category: 'Skin Care', subcategories: ['Estheticians'] },
  { category: 'Tanning', subcategories: ['Spray Tanning', 'Tanning Beds'] },
  { category: 'Tattoo', subcategories: [] },
  { category: 'Teeth Whitening', subcategories: [] }
];

export const Cat5Options = [
  { category: 'Arcades', subcategories: [] },
  { category: 'Art Galleries', subcategories: [] },
  { category: 'Bingo Halls', subcategories: [] },
  { category: 'Botanical Gardens', subcategories: [] },
  { category: 'Cabaret', subcategories: [] },
  { category: 'Casinos', subcategories: [] },
  { category: 'Cinema', subcategories: ['Drive-In Theater', 'Outdoor Movies'] },
  { category: 'Country Clubs', subcategories: [] },
  { category: 'Cultural Center', subcategories: [] },
  { category: 'Entertainment', subcategories: [] },
  { category: 'Farms', subcategories: ['Attraction Farms', 'Pick Your Own Farms', 'Ranches'] },
  { category: 'Festivals', subcategories: [] },
  { category: 'Haunted Houses', subcategories: [] },
  { category: 'Jazz & Blues', subcategories: [] },
  { category: 'LAN Centers', subcategories: [] },
  { category: 'Makerspaces', subcategories: [] },
  { category: 'Museums', subcategories: ['Art Museums', 'Children’s Museums'] },
  { category: 'Music Venues', subcategories: [] },
  { category: 'Observatories', subcategories: [] },
  { category: 'Opera & Ballet', subcategories: [] },
  { category: 'Paint & Sip', subcategories: [] },
  { category: 'Performing Arts', subcategories: [] },
  { category: 'Planetarium', subcategories: [] },
  { category: 'Professional Sports Teams', subcategories: [] },
  { category: 'Race Tracks', subcategories: [] },
  { category: 'Rodeo', subcategories: [] },
  { category: 'Social Clubs', subcategories: [] },
  { category: 'Veterans Organizations', subcategories: [] },
  { category: 'Sports Betting', subcategories: [] },
  { category: 'Stadiums & Arenas', subcategories: [] },
  { category: 'Studio Taping', subcategories: [] },
  { category: 'Supernatural Readings', subcategories: ['Astrologers', 'Mystics', 'Psychic Mediums', 'Psychics'] },
  { category: 'Tablao Flamenco', subcategories: [] },
  { category: 'Ticket Sales', subcategories: [] },
  { category: 'Virtual Reality Centers', subcategories: [] },
  { category: 'Wineries', subcategories: ['Wine Tasting Room'] }
];

export const Cat6Options = [
  { category: 'Airsoft', subcategories: [] },
  { category: 'Amateur Sports Teams', subcategories: [] },
  { category: 'Amusement Parks', subcategories: [] },
  { category: 'Aquariums', subcategories: [] },
  { category: 'Archery', subcategories: [] },
  { category: 'ATV Rentals/Tours', subcategories: [] },
  { category: 'Axe Throwing', subcategories: [] },
  { category: 'Badminton', subcategories: [] },
  { category: 'Baseball Fields', subcategories: [] },
  { category: 'Basketball Courts', subcategories: [] },
  { category: 'Bathing Area', subcategories: [] },
  { category: 'Batting Cages', subcategories: [] },
  { category: 'Beach Equipment Rentals', subcategories: [] },
  { category: 'Beach Volleyball', subcategories: [] },
  { category: 'Beaches', subcategories: [] },
  { category: 'Bicycle Paths', subcategories: [] },
  { category: 'Bike Parking', subcategories: [] },
  { category: 'Bike Rentals', subcategories: [] },
  { category: 'Boating', subcategories: [] },
  { category: 'Bobsledding', subcategories: [] },
  { category: 'Bocce Ball', subcategories: [] },
  { category: 'Bowling', subcategories: [] },
  { category: 'Bubble Soccer', subcategories: [] },
  { category: 'Bungee Jumping', subcategories: [] },
  { category: 'Canyoneering', subcategories: [] },
  { category: 'Carousels', subcategories: [] },
  { category: 'Challenge Courses', subcategories: [] },
  { category: 'Climbing', subcategories: [] },
  { category: 'Cycling Classes', subcategories: [] },
  { category: 'Dart Arenas', subcategories: [] },
  { category: 'Day Camps', subcategories: [] },
  { category: 'Disc Golf', subcategories: [] },
  { category: 'Diving', subcategories: ['Free Diving', 'Scuba Diving'] },
  { category: 'Escape Games', subcategories: [] },
  { category: 'Experiences', subcategories: [] },
  { category: 'Fencing Clubs', subcategories: [] },
  { category: 'Fishing', subcategories: [] },
  { category: 'Fitness & Instruction', subcategories: [
    'Aerial Fitness',
    'Barre Classes',
    'Boot Camps',
    'Boxing',
    'Cardio Classes',
    'Dance Studios',
    'EMS Training',
    'Golf Lessons',
    'Gyms',
    'Circuit Training Gyms',
    'Interval Training Gyms'
  ] },
  { category: 'Martial Arts', subcategories: [
    'Brazilian Jiu-jitsu',
    'Chinese Martial Arts',
    'Karate',
    'Kickboxing',
    'Muay Thai',
    'Taekwondo'
  ] },
  { category: 'Meditation Centers', subcategories: [] },
  { category: 'Pilates', subcategories: [] },
  { category: 'Qi Gong', subcategories: [] },
  { category: 'Self-defense Classes', subcategories: [] },
  { category: 'Swimming Lessons/Schools', subcategories: [] },
  { category: 'Tai Chi', subcategories: [] },
  { category: 'Trainers', subcategories: [] },
  { category: 'Yoga', subcategories: [] },
  { category: 'Flyboarding', subcategories: [] },
  { category: 'Gliding', subcategories: [] },
  { category: 'Go Karts', subcategories: [] },
  { category: 'Golf', subcategories: [] },
  { category: 'Gun/Rifle Ranges', subcategories: [] },
  { category: 'Gymnastics', subcategories: [] },
  { category: 'Handball', subcategories: [] },
  { category: 'Hang Gliding', subcategories: [] },
  { category: 'Hiking', subcategories: [] },
  { category: 'Horse Racing', subcategories: [] },
  { category: 'Horseback Riding', subcategories: [] },
  { category: 'Hot Air Balloons', subcategories: [] },
  { category: 'Indoor Playcentre', subcategories: [] },
  { category: 'Jet Skis', subcategories: [] },
  { category: 'Kids Activities', subcategories: [] },
  { category: 'Kiteboarding', subcategories: [] },
  { category: 'Lakes', subcategories: [] },
  { category: 'Laser Tag', subcategories: [] },
  { category: 'Lawn Bowling', subcategories: [] },
  { category: 'Mini Golf', subcategories: [] },
  { category: 'Mountain Biking', subcategories: [] },
  { category: 'Nudist', subcategories: [] },
  { category: 'Paddleboarding', subcategories: [] },
  { category: 'Paintball', subcategories: [] },
  { category: 'Paragliding', subcategories: [] },
  { category: 'Parasailing', subcategories: [] },
  { category: 'Parks', subcategories: ['Dog Parks', 'Skate Parks'] },
  { category: 'Pickleball', subcategories: [] },
  { category: 'Playgrounds', subcategories: [] },
  { category: 'Public Plazas', subcategories: [] },
  { category: 'Races & Competitions', subcategories: [] },
  { category: 'Racing Experience', subcategories: [] },
  { category: 'Rafting/Kayaking', subcategories: [] },
  { category: 'Recreation Centers', subcategories: [] },
  { category: 'Rock Climbing', subcategories: [] },
  { category: 'Sailing', subcategories: [] },
  { category: 'Scavenger Hunts', subcategories: [] },
  { category: 'Scooter Rentals', subcategories: [] },
  { category: 'Senior Centers', subcategories: [] },
  { category: 'Skating Rinks', subcategories: [] },
  { category: 'Skiing', subcategories: [] },
  { category: 'Skydiving', subcategories: [] },
  { category: 'Sledding', subcategories: [] },
  { category: 'Snorkeling', subcategories: [] },
  { category: 'Soccer', subcategories: [] },
  { category: 'Sport Equipment Hire', subcategories: [] },
  { category: 'Sports Clubs', subcategories: [] },
  { category: 'Squash', subcategories: [] },
  { category: 'Summer Camps', subcategories: [] },
  { category: 'Surf Lifesaving', subcategories: [] },
  { category: 'Surfing', subcategories: [] },
  { category: 'Swimming Pools', subcategories: [] },
  { category: 'Tennis', subcategories: [] },
  { category: 'Trampoline Parks', subcategories: [] },
  { category: 'Tubing', subcategories: [] },
  { category: 'Volleyball', subcategories: [] },
  { category: 'Water Parks', subcategories: [] },
  { category: 'Wildlife Hunting Ranges', subcategories: [] },
  { category: 'Ziplining', subcategories: [] },
  { category: 'Zoos', subcategories: ['Petting Zoos'] },
  { category: 'Zorbing', subcategories: [] }
];

export const Cat7Options = [
  { category: 'Airports', subcategories: ['Airport Terminals'] },
  { category: 'Bed & Breakfast', subcategories: [] },
  { category: 'Campgrounds', subcategories: [] },
  { category: 'Car Rental', subcategories: [] },
  { category: 'Guest Houses', subcategories: [] },
  { category: 'Health Retreats', subcategories: [] },
  { category: 'Hostels', subcategories: [] },
  { category: 'Hotels', subcategories: [
    'Mountain Huts',
    'Residences',
    'Rest Stops'
  ] },
  { category: 'Motorcycle Rental', subcategories: [] },
  { category: 'RV Parks', subcategories: [] },
  { category: 'RV Rental', subcategories: [] },
  { category: 'Resorts', subcategories: [] },
  { category: 'Ski Resorts', subcategories: [] },
  { category: 'Tours', subcategories: [
    'Aerial Tours',
    'Architectural Tours',
    'Art Tours',
    'Beer Tours',
    'Bike Tours',
    'Boat Tours',
    'Bus Tours',
    'Food Tours',
    'Historical Tours',
    'Scooter Tours',
    'Walking Tours',
    'Whale Watching Tours',
    'Wine Tours'
  ] },
  { category: 'Train Stations', subcategories: [] },
  { category: 'Transportation', subcategories: [
    'Airlines',
    'Airport Shuttles',
    'Bike Sharing',
    'Ferries',
    'Limos',
    'Metro Stations',
    'Pedicabs',
    'Private Jet Charter',
    'Public Transportation',
    'Taxis',
    'Town Car Service',
    'Trains'
  ] },
  { category: 'Travel Services', subcategories: [
    'Luggage Storage',
    'Passport & Visa Services',
    'Travel Agents',
    'Visitor Centers'
  ] },
  { category: 'Vacation Rental Agents', subcategories: [] },
  { category: 'Vacation Rentals', subcategories: [] }
];

export const Cat8Options = [
  { category: 'Adult', subcategories: [] },
  { category: 'Antiques', subcategories: [] },
  { category: 'Art Galleries', subcategories: [] },
  { category: 'Arts & Crafts', subcategories: [
    'Art Supplies',
    'Ateliers',
    'Cards & Stationery',
    'Cooking Classes',
    'Costumes',
    'Embroidery & Crochet',
    'Fabric Stores',
    'Framing',
    'Paint-Your-Own Pottery'
  ] },
  { category: 'Auction Houses', subcategories: [] },
  { category: 'Baby Gear & Furniture', subcategories: [] },
  { category: 'Battery Stores', subcategories: [] },
  { category: 'Bespoke Clothing', subcategories: [] },
  { category: 'Books, Mags, Music & Video', subcategories: [
    'Bookstores',
    'Comic Books',
    'Music & DVDs',
    'Newspapers & Magazines',
    'Video Game Stores',
    'Videos & Video Game Rental',
    'Vinyl Records'
  ] },
  { category: 'Brewing Supplies', subcategories: [] },
  { category: 'Bridal', subcategories: [] },
  { category: 'Cannabis Dispensaries', subcategories: [] },
  { category: 'Chinese Bazaar', subcategories: [] },
  { category: 'Computers', subcategories: [] },
  { category: 'Concept Shops', subcategories: [] },
  { category: 'Cosmetics & Beauty Supply', subcategories: [] },
  { category: 'Customized Merchandise', subcategories: [] },
  { category: 'Department Stores', subcategories: [] },
  { category: 'Diamond Buyers', subcategories: [] },
  { category: 'Discount Store', subcategories: [] },
  { category: 'Drones', subcategories: [] },
  { category: 'Drugstores', subcategories: [] },
  { category: 'Duty-Free Shops', subcategories: [] },
  { category: 'Electronics', subcategories: [] },
  { category: 'Eyewear & Opticians', subcategories: [
    'Sunglasses'
  ] },
  { category: 'Farming Equipment', subcategories: [] },
  { category: 'Fashion', subcategories: [
    'Accessories',
    'Ceremonial Clothing',
    'Children’s Clothing',
    'Clothing Rental',
    'Department Stores',
    'Formal Wear',
    'Fur Clothing',
    'Hats',
    'Kimonos',
    'Leather Goods',
    'Lingerie',
    'Maternity Wear',
    'Men’s Clothing',
    'Plus Size Fashion',
    'Shoe Stores',
    'Sleepwear',
    'Sports Wear',
    'Dance Wear',
    'Stockings',
    'Surf Shop',
    'Swimwear',
    'Traditional Clothing',
    'Used, Vintage & Consignment',
    'Women’s Clothing'
  ] },
  { category: 'Fireworks', subcategories: [] },
  { category: 'Fitness/Exercise Equipment', subcategories: [] },
  { category: 'Flea Markets', subcategories: [] },
  { category: 'Flowers & Gifts', subcategories: [
    'Cards & Stationery',
    'Florists',
    'Gift Shops'
  ] },
  { category: 'Gemstones & Minerals', subcategories: [] },
  { category: 'Gold Buyers', subcategories: [] },
  { category: 'Guns & Ammo', subcategories: [] },
  { category: 'Head Shops', subcategories: [] },
  { category: 'High Fidelity Audio Equipment', subcategories: [] },
  { category: 'Hobby Shops', subcategories: [] },
  { category: 'Home & Garden', subcategories: [
    'Appliances',
    'Candle Stores',
    'Christmas Trees',
    'Furniture Stores',
    'Grilling Equipment',
    'Hardware Stores',
    'Holiday Decorations',
    'Home Decor',
    'Hot Tub & Pool',
    'Kitchen & Bath',
    'Kitchen Supplies',
    'Lighting Stores',
    'Linens',
    'Materiale elettrico',
    'Mattresses',
    'Nurseries & Gardening',
    'Hydroponics',
    'Outdoor Furniture Stores',
    'Paint Stores',
    'Playsets',
    'Pumpkin Patches',
    'Rugs',
    'Sheds & Outdoor Storage',
    'Tableware'
  ] },
  { category: 'Horse Equipment Shops', subcategories: [] },
  { category: 'Jewelry', subcategories: [] },
  { category: 'Kiosk', subcategories: [] },
  { category: 'Knitting Supplies', subcategories: [] },
  { category: 'Livestock Feed & Supply', subcategories: [] },
  { category: 'Luggage', subcategories: [] },
  { category: 'Market Stalls', subcategories: [] },
  { category: 'Medical Supplies', subcategories: [] },
  { category: 'Military Surplus', subcategories: [] },
  { category: 'Mobile Phone Accessories', subcategories: [] },
  { category: 'Mobile Phones', subcategories: [] },
  { category: 'Motorcycle Gear', subcategories: [] },
  { category: 'Musical Instruments & Teachers', subcategories: [] },
  { category: 'Office Equipment', subcategories: [] },
  { category: 'Outlet Stores', subcategories: [] },
  { category: 'Packing Supplies', subcategories: [] },
  { category: 'Pawn Shops', subcategories: [] },
  { category: 'Perfume', subcategories: [] },
  { category: 'Personal Shopping', subcategories: [] },
  { category: 'Photography Stores & Services', subcategories: [] },
  { category: 'Pool & Billiards', subcategories: [] },
  { category: 'Pop-up Shops', subcategories: [] },
  { category: 'Props', subcategories: [] },
  { category: 'Public Markets', subcategories: [] },
  { category: 'Religious Items', subcategories: [] },
  { category: 'Safe Stores', subcategories: [] },
  { category: 'Safety Equipment', subcategories: [] },
  { category: 'Scandinavian Design', subcategories: [] },
  { category: 'Shopping Centers', subcategories: [] },
  { category: 'Shopping Passages', subcategories: [] },
  { category: 'Souvenir Shops', subcategories: [] },
  { category: 'Spiritual Shop', subcategories: [] },
  { category: 'Sporting Goods', subcategories: [
    'Bikes',
    'Dive Shops',
    'Golf Equipment',
    'Hockey Equipment',
    'Hunting & Fishing Supplies',
    'Outdoor Gear',
    'Skate Shops',
    'Ski & Snowboard Shops',
    'Sports Wear'
  ] },
  { category: 'Tabletop Games', subcategories: [] },
  { category: 'Teacher Supplies', subcategories: [] },
  { category: 'Thrift Stores', subcategories: [] },
  { category: 'Tickets', subcategories: [] },
  { category: 'Tobacco Shops', subcategories: [] },
  { category: 'Toy Stores', subcategories: [] },
  { category: 'Trophy Shops', subcategories: [] },
  { category: 'Uniforms', subcategories: [] },
  { category: 'Used Bookstore', subcategories: [] },
  { category: 'Vape Shops', subcategories: [] },
  { category: 'Vitamins & Supplements', subcategories: [] },
  { category: 'Watches', subcategories: [] },
  { category: 'Wholesale Stores', subcategories: [] },
  { category: 'Wigs', subcategories: [] }
];

export const Cat9Options = [
  { category: 'Balloon Services', subcategories: [] },
  { category: 'Bartenders', subcategories: [] },
  { category: 'Boat Charters', subcategories: [] },
  { category: 'Cards & Stationery', subcategories: [] },
  { category: 'Caricatures', subcategories: [] },
  { category: 'Caterers', subcategories: [] },
  { category: 'Clowns', subcategories: [] },
  { category: 'DJs', subcategories: [] },
  { category: 'Face Painting', subcategories: [] },
  { category: 'Floral Designers', subcategories: [] },
  { category: 'Game Truck Rental', subcategories: [] },
  { category: 'Golf Cart Rentals', subcategories: [] },
  { category: 'Henna Artists', subcategories: [] },
  { category: 'Hotels', subcategories: [
    'Agriturismi',
    'Mountain Huts',
    'Pensions',
    'Residences',
    'Rest Stops',
    'Ryokan'
  ] },
  { category: 'Magicians', subcategories: [] },
  { category: 'Mohels', subcategories: [] },
  { category: 'Musicians', subcategories: [] },
  { category: 'Officiants', subcategories: [] },
  { category: 'Party & Event Planning', subcategories: [] },
  { category: 'Party Bike Rentals', subcategories: [] },
  { category: 'Party Bus Rentals', subcategories: [] },
  { category: 'Party Characters', subcategories: [] },
  { category: 'Party Equipment Rentals', subcategories: [
    'Audio/Visual Equipment Rental',
    'Bounce House Rentals',
    'Karaoke Rental'
  ] },
  { category: 'Party Supplies', subcategories: [] },
  { category: 'Personal Chefs', subcategories: [] },
  { category: 'Photo Booth Rentals', subcategories: [] },
  { category: 'Photographers', subcategories: [
    'Boudoir Photography',
    'Event Photography',
    'Session Photography'
  ] },
  { category: 'Silent Disco', subcategories: [] },
  { category: 'Sommelier Services', subcategories: [] },
  { category: 'Team Building Activities', subcategories: [] },
  { category: 'Trivia Hosts', subcategories: [] },
  { category: 'Valet Services', subcategories: [] },
  { category: 'Venues & Event Spaces', subcategories: [] },
  { category: 'Videographers', subcategories: [] },
  { category: 'Wedding Chapels', subcategories: [] },
  { category: 'Wedding Planning', subcategories: [] }
];


export const Cat10Options = [
  { category: 'Accountants', subcategories: [] },
  { category: 'Advertising', subcategories: [] },
  { category: 'Architects', subcategories: [] },
  { category: 'Art Consultants', subcategories: [] },
  { category: 'Billing Services', subcategories: [] },
  { category: 'Boat Repair', subcategories: [] },
  { category: 'Bookkeepers', subcategories: [] },
  { category: 'Business Consulting', subcategories: [] },
  { category: 'Career Counseling', subcategories: [] },
  { category: 'Commissioned Artists', subcategories: [] },
  { category: 'Customs Brokers', subcategories: [] },
  { category: 'Digitizing Services', subcategories: [] },
  { category: 'Duplication Services', subcategories: [] },
  { category: 'Editorial Services', subcategories: [] },
  { category: 'Employment Agencies', subcategories: [] },
  { category: 'Feng Shui', subcategories: [] },
  { category: 'Graphic Design', subcategories: [] },
  { category: 'Indoor Landscaping', subcategories: [] },
  { category: 'Internet Service Providers', subcategories: [] },
  { category: 'Lawyers', subcategories: [
    'Bankruptcy Law',
    'Business Law',
    'Consumer Law',
    'Contract Law',
    'Criminal Defense Law',
    'Disability Law',
    'Divorce & Family Law',
    'DUI Law',
    'Elder Law',
    'Employment Law',
    'Entertainment Law',
    'Estate Planning Law',
    'Wills, Trusts, & Probates',
    'General Litigation',
    'Immigration Law',
    'IP & Internet Law',
    'Medical Law',
    'Personal Injury Law',
    'Real Estate Law',
    'Social Security Law',
    'Tax Law',
    'Traffic Ticketing Law',
    'Workers Compensation Law'
  ] },
  { category: 'Legal Services', subcategories: [
    'Court Reporters'
  ] },
  { category: 'Process Servers', subcategories: [] },
  { category: 'Life Coach', subcategories: [] },
  { category: 'Marketing', subcategories: [] },
  { category: 'Matchmakers', subcategories: [] },
  { category: 'Mediators', subcategories: [] },
  { category: 'Music Production Services', subcategories: [] },
  { category: 'Office Cleaning', subcategories: [] },
  { category: 'Patent Law', subcategories: [] },
  { category: 'Payroll Services', subcategories: [] },
  { category: 'Personal Assistants', subcategories: [] },
  { category: 'Private Investigation', subcategories: [] },
  { category: 'Product Design', subcategories: [] },
  { category: 'Public Adjusters', subcategories: [] },
  { category: 'Public Relations', subcategories: [] },
  { category: 'Security Services', subcategories: [] },
  { category: 'Shredding Services', subcategories: [] },
  { category: 'Signmaking', subcategories: [] },
  { category: 'Software Development', subcategories: [] },
  { category: 'Talent Agencies', subcategories: [] },
  { category: 'Taxidermy', subcategories: [] },
  { category: 'Tenant and Eviction Law', subcategories: [] },
  { category: 'Translation Services', subcategories: [] },
  { category: 'Video/Film Production', subcategories: [] },
  { category: 'Web Design', subcategories: [] },
  { category: 'Wholesalers', subcategories: [] },
  { category: 'Restaurant Supplies', subcategories: [] }
];

export const Cat11Options = [
  { category: 'Animal Shelters', subcategories: [] },
  { category: 'Horse Boarding', subcategories: [] },
  { category: 'Pet Adoption', subcategories: [] },
  { category: 'Pet Services', subcategories: [
    'Animal Physical Therapy',
    'Aquarium Services',
    'Dog Walkers',
    'Emergency Pet Hospital',
    'Farriers',
    'Holistic Animal Care',
    'Pet Boarding',
    'Pet Breeders',
    'Pet Cremation Services',
    'Pet Groomers',
    'Pet Hospice',
    'Pet Insurance',
    'Pet Photography',
    'Pet Sitting',
    'Pet Training',
    'Pet Transportation',
    'Pet Waste Removal'
  ] },
  { category: 'Pet Stores', subcategories: [
    'Bird Shops',
    'Local Fish Stores',
    'Reptile Shops',
    'Veterinarians'
  ] }
];

export const Cat12Options = [
  { category: 'Adult Entertainment', subcategories: [
    'Strip Clubs',
    'Striptease Dancers'
  ] },
  { category: 'Bar Crawl', subcategories: [] },
  { category: 'Bars', subcategories: [
    'Airport Lounges',
    'Beer Bar',
    'Champagne Bars',
    'Cigar Bars',
    'Cocktail Bars',
    'Dive Bars',
    'Drive-Thru Bars',
    'Gay Bars',
    'Hookah Bars',
    'Irish Pub',
    'Lounges',
    'Pubs',
    'Speakeasies',
    'Sports Bars',
    'Tiki Bars',
    'Vermouth Bars',
    'Whiskey Bars',
    'Wine Bars'
  ] },
  { category: 'Beer Gardens', subcategories: [] },
  { category: 'Club Crawl', subcategories: [] },
  { category: 'Comedy Clubs', subcategories: [] },
  { category: 'Country Dance Halls', subcategories: [] },
  { category: 'Dance Clubs', subcategories: [] },
  { category: 'Jazz & Blues', subcategories: [] },
  { category: 'Karaoke', subcategories: [] },
  { category: 'Music Venues', subcategories: [] },
  { category: 'Piano Bars', subcategories: [] },
  { category: 'Pool Halls', subcategories: [] }
];

export const GOOGLE_CLIENT_ID =  "385401862573-gr8sbudg3525in9enb3pqr56ndpvfkqo.apps.googleusercontent.com"